import { render, staticRenderFns } from "./HospitalInformationDetail.vue?vue&type=template&id=6519a10f&"
import script from "./HospitalInformationDetail.vue?vue&type=script&lang=js&"
export * from "./HospitalInformationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports